import Button from 'components/Button';
import { useNavigate } from 'react-router';
import { useAuth } from 'context/AuthContext';
import CustomModal from 'components/CustomModal';

interface ComplianceModalProps {
  isOpen: boolean;
}

const ComplianceModal = ({ isOpen }: ComplianceModalProps) => {
  const { username } = useAuth();
  const navigate = useNavigate();

  const handleReviewBtn = () => {
    navigate('/company-data');
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={() => {}}
      className='flex flex-col gap-4 max-w-[480px] p-8 rounded-2xl overflow-hidden'
    >
      <p className='font-semibold text-[28px]'>
        Hi {username}!
        <br />
        Welcome to Compass!
      </p>

      <p className='font-light text-base text-gray-700'>
        Before we start, you have the opportunity to review and confirm your
        data that we have collected on your behalf through board meeting
        presentations or direct correspondence with you. If we have enough
        information, this data can be viewed directly with our benchmarks, and
        it can also be edited if there have been restatements or if additional
        details are available. Data security is of paramount importance to us,
        so please allow us time to approve your login credentials.
      </p>

      <Button
        id='review'
        label='Review my data'
        onClick={handleReviewBtn}
        className='w-full mt-4 px-5 py-2 rounded-5xl text-lg font-light text-center text-white bg-black dark:bg-white dark:text-black hover:bg-gray-850 dark:hover:bg-gray-400 transition-all duration-300'
      />
    </CustomModal>
  );
};

export default ComplianceModal;
